import React from 'react'

import ActionButton from '@/components/misc/ActionButton'
import InvitingColleagueWarningMessage from '@/components/misc/InviteOrRequestReferralPartners/components/InvitingColleagueWarningMessage'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface Props {
  recipientsWithSameEmailDomain: string[]
  isProcessing: boolean
  onHide: () => void
  onSend: () => void
}

const ConfirmSendToColleagueModal: React.FC<Props> = ({
  recipientsWithSameEmailDomain,
  isProcessing,
  onHide,
  onSend,
}) => (
  <Dialog open onHide={onHide}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>
          Are you sure you want to send a referral partner invite?
        </DialogTitle>
      </DialogHeader>

      <DialogBody>
        <InvitingColleagueWarningMessage
          recipientsWithSameEmailDomain={recipientsWithSameEmailDomain}
        />
      </DialogBody>

      <DialogFooter>
        <Button onClick={onHide} variant="outline-secondary">
          No, cancel
        </Button>

        <ActionButton
          isProcessing={isProcessing}
          isProcessingText="Sending"
          variant="primary"
          onClick={onSend}
        >
          Yes, send invite
        </ActionButton>
      </DialogFooter>
    </DialogContent>
  </Dialog>
)

export default ConfirmSendToColleagueModal
